import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, SearchManagementBreedersUsersAction} from '../action';

function* execute({payload}: SearchManagementBreedersUsersAction): SagaIterator {
    yield* put(adminAction.setLoading('getUsers', true));
    const response = yield* call(Api.searchUsers, {text: payload});

    if (response.isSuccess) {
        yield* put(adminAction.setManagementBreedersUsers(response.data));
    } else {
        yield putAll(showBeError(response, t('admin')('subjectsLoading')));
    }
    yield* put(adminAction.setLoading('getUsers', false));
}

/** Runs the admin saga that searches users for the breeder-management form. */
export function* searchManagementBreedersUsersSaga(): SagaIterator {
    yield takeLatestF('admin/SEARCH_MANAGEMENT_BREEDERS_USERS', execute);
}
